<template>
  <div>
    <template v-if="num!=null">
      <div id="elect">
        <div
          id="enow"
          :style="{
            width: num + '%',
            background: num <= 20 ? 'red' : '#0ab927',
          }"
        ></div>
      </div>
      <span>{{ num == null ? 0 : num }}%</span>
    </template>
    <template v-else>
       暂无电量数据
    </template>
  </div>
</template>
<script>
export default {
  props: ["num"],
};
</script>
<style lang="">
#elect {
  width: 20px;
  height: 10px;
  border: solid 1px #999;
  position: relative;
  display: inline-block;
  margin-right: 4px;
}
#elect::after {
  content: "";
  width: 2px;
  height: 4px;
  background: #999;
  position: absolute;
  right: -3px;
  top: 2px;
}
#enow {
  height: 100%;
  width: 0%;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/elect.vue